import * as _ from 'lodash';
import { getWindow } from './globalWrappers';
const sharedConstants = getWindow().SHARED_CONSTANTS;
const { AutoLoanPurposeTypes, AutoVehicleConditionTypes, AutoRefinanceTypes, AutoProducts } = sharedConstants;

export function getAutoProductType(autoApplication) {
  if (!autoApplication) return null;
  switch (autoApplication.loanPurposeType) {
    case AutoLoanPurposeTypes.PURCHASE:
      if (autoApplication.vehicleCondition === AutoVehicleConditionTypes.USED) return AutoProducts.PURCHASE_USED;
      if (autoApplication.vehicleCondition === AutoVehicleConditionTypes.NEW) return AutoProducts.PURCHASE_NEW;
      return null;

    case AutoLoanPurposeTypes.REFINANCE:
      if (autoApplication.refinanceType === AutoRefinanceTypes.CASH_OUT) return AutoProducts.REFI_CASHOUT;
      if (autoApplication.refinanceType === AutoRefinanceTypes.LOAN) return AutoProducts.REFI_STANDARD;
      return null;

    case AutoLoanPurposeTypes.LEASE_BUYOUT:
      return AutoProducts.LEASE_BUYOUT;

    default:
      return null;
  }
}

export function getAutoProductDescription(autoProductType: AutoProduct | null): string | null {
  if (!autoProductType) return null;
  const autoProduct: EnumerationChoices<AutoProduct> | undefined = _.find(AutoProducts.ALL_RICH, {
    value: autoProductType,
  });
  return autoProduct ? autoProduct.text : null;
}
